module.exports = __webpack_public_path__ + "static/media/logo.19d545a3.png";